import React, { useEffect } from "react";
import { themeStore } from "stores/themeStore.store";
import { usePermissions } from "utils/hooks/usePermissions";
import { Navigate, useLocation } from "react-router-dom";
import { adminStore } from "stores/admin.store";
import { authStore } from "stores/auth.store";
import Loading from "components/shared-components/Loading";
import { getOnboardingPath } from "utils/onboarding";
const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  bypassOnboarding,
  permissions = [],
  roles = [],
  allowedIf,
  ...props
}) => {
  const { userProfile, profileLoaded } = adminStore();
  const { isAuthenticated } = authStore();
  const hasPermission = usePermissions();
  const location = useLocation();

  if (isAuthenticated && !profileLoaded) {
    return <Loading cover="page" />;
  }

  // Run this early so users typing URLs directly get intercepted right away
  if (allowedIf && typeof allowedIf === "function") {
    if (!allowedIf(userProfile)) {
      return <Navigate to="/home" replace />;
    }
  }

  const ONBOARDING_PATH = getOnboardingPath(userProfile);

  // ONBOARDING GUARD
  if (
    userProfile?.isOnboarding &&
    !bypassOnboarding &&
    !location.pathname.startsWith(ONBOARDING_PATH)
  ) {
    return <Navigate to={ONBOARDING_PATH} replace />;
  }

  // PERMISSIONS GUARD
  if (permissions.length > 0 && !hasPermission(permissions)) {
    return <Navigate to="/error-page" state={{ from: location }} replace />;
  }

  // ROLE GUARD
  if (Array.isArray(roles) && roles.length > 0) {
    const userType = userProfile?.userType;
    if (!userType || !roles.includes(userType)) {
      return <Navigate to="/error-page" state={{ from: location }} replace />;
    }
  }

  if (userProfile?.userType === "backOffice" && routeKey === "home") {
    return <Navigate to="/customer-management" replace />;
  }

  return <Component {...props} />;
};

export default AppRoute;
